import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

// Figma "Badge" (ver.6): Brand = #FFF5ED + 1px #FFCDA8 / 700 #1A1C21, r8 (e.g. "PwC Certified"); Inverse = #1A1C21 / white, r6 (e.g. agent type "플랫폼형 솔루션").
const nvBadgeVariants = cva("inline-flex items-center whitespace-nowrap px-[10px] py-1 text-nv-tag", {
  variants: {
    tone: {
      brand: "rounded-nv-chip border border-nv-brand-border bg-nv-brand-subtle font-bold text-nv-text-primary",
      inverse: "rounded-nv-pill bg-nv-surface-slate text-nv-text-inverse",
    },
  },
  defaultVariants: {
    tone: "brand",
  },
});

export interface NvBadgeProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof nvBadgeVariants> {}

function NvBadge({ className, tone, ...props }: NvBadgeProps) {
  return <span className={cn(nvBadgeVariants({ tone }), className)} {...props} />;
}

export { NvBadge, nvBadgeVariants };
